import { Home, ChevronRight } from 'lucide-react';

type Crumb = {
  label: string;
  onClick?: () => void;
};

type BreadcrumbsProps = {
  items: Crumb[];
};

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="max-w-6xl mx-auto px-4 sm:px-6 pt-4">
      <ol className="flex items-center gap-1 text-xs text-ash-600 flex-wrap">
        <li>
          <button
            onClick={items[0].onClick}
            className="flex items-center gap-1 hover:text-snow transition"
          >
            <Home className="w-3.5 h-3.5" />
            <span>Home</span>
          </button>
        </li>
        {items.slice(1).map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            <ChevronRight className="w-3.5 h-3.5 text-ash-600" />
            {item.onClick ? (
              <button onClick={item.onClick} className="hover:text-snow transition">
                {item.label}
              </button>
            ) : (
              <span className="text-snow font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
